import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=276ad272&"
import script from "./PropertyDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PropertyDetails.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports